import { atom } from 'recoil'
import { IPassportSchema } from '@/pages/MDM/mdm.types.ts'

export interface IPassportSchemasAtomState {
  items: IPassportSchema[]
}

const passportSchemasAtom = atom<IPassportSchemasAtomState>({ key: '/mdm/passports', default: { items: [] } })
export default passportSchemasAtom
